import { useCallback, useEffect, useMemo, useState } from 'react'

import { useAppDispatch } from '@/hooks/redux'
import { FORM_FIELDS } from '@/pages/getRecipe/fullMonolithic/materialAdvice/utils/formTypes'
import { useAppSelector } from '@/store'
import { removeFrameWorkIndex } from '@/store/appSlice'
import { resetFrameworkRecipeState } from '@/store/fullMonoLithic'
import { Workflows, showPrepColorPicker } from '@/utils/constants'

import MaterialAdviceTooltip from './components/MatrialAdviceTooltip'

const KonvaFMMaterialAdvice = () => {
  const dispatch = useAppDispatch()
  const materialAdviceOuput = useAppSelector(
    (state) => state.fullMonolithic.materialAdviceOuput,
  )

  const targetColor = useAppSelector(
    (state) => state.fullMonolithic.materialTargetColor,
  )

  const selectedIndication = useAppSelector(
    (state) => state.fullMonolithic.materialAdviceForm[FORM_FIELDS.INDICATION],
  )

  const canvasImage = useAppSelector((state) => state.app.canvasImage)

  const [tooltipOpen, setTooltipOpen] = useState<boolean>(true)
  const [lockedPosition, setLockedPosition] = useState<{
    x: number
    y: number
  } | null>(null)
  const [prevOutputJson, setPrevOutputJson] = useState<string>('')

  const handleToggleTooltip = useCallback(() => {
    setTooltipOpen((prev) => !prev)
  }, [])

  const handleCloseTooltip = useCallback(() => {
    setTooltipOpen(false)
  }, [])

  const outputData = materialAdviceOuput?.[canvasImage?.id]
  const colorData = targetColor

  const shouldUseIncisal = useMemo(
    () => showPrepColorPicker.includes(selectedIndication),
    [selectedIndication],
  )

  const regionKey =
    shouldUseIncisal && colorData?.INCISAL?.imagePosition ? 'INCISAL' : 'MIDDLE'

  const regionData = colorData?.[regionKey]?.imagePosition

  useEffect(() => {
    const currentOutputJson = JSON.stringify(outputData)

    if (outputData && currentOutputJson !== prevOutputJson && regionData) {
      setLockedPosition(regionData)
      setPrevOutputJson(currentOutputJson)
    }
  }, [outputData, regionData, prevOutputJson])

  const handleDeleteFramework = useCallback(() => {
    if (!canvasImage?.id) return

    dispatch(resetFrameworkRecipeState({ imageId: canvasImage.id }))
    dispatch(
      removeFrameWorkIndex({
        workflow: Workflows.FULL_MONOLITHIC,
        imageId: canvasImage.id,
      }),
    )
  }, [dispatch, canvasImage?.id])

  if (!outputData || !lockedPosition) return null

  return (
    <MaterialAdviceTooltip
      key={regionKey}
      keyName={regionKey}
      data={lockedPosition}
      output={outputData}
      open={tooltipOpen}
      toggle={handleToggleTooltip}
      close={handleCloseTooltip}
      workflow={Workflows?.FULL_MONOLITHIC}
      onDelete={handleDeleteFramework}
    />
  )
}

export default KonvaFMMaterialAdvice
